import { createSlice } from "@reduxjs/toolkit";
import { StatusBar } from "./types";
import getCurrentDate from "../../../../utils/getCurrentDate";

const initialState: StatusBar = {
  isConnected: false,
  lastConnectionTime: null,
};

const options = {
  name: "statusBar",
  initialState,
  reducers: {
    updateConnectionTime: (state: StatusBar) => {
      state.lastConnectionTime = getCurrentDate();
    },
    setConnected: (state: StatusBar) => {
      state.isConnected = true;
      state.lastConnectionTime = getCurrentDate();
    },
    setDisconnected: (state: StatusBar) => {
      state.isConnected = false;
      state.lastConnectionTime = null;
    },
  },
};

const statusBarSlice = createSlice(options);

export const { setConnected, setDisconnected, updateConnectionTime } = statusBarSlice.actions;

export const selectIsConnected = (state: { statusBar: StatusBar }) => state.statusBar.isConnected;
export const selectLastConnectionTime = (state: { statusBar: StatusBar }) => state.statusBar.lastConnectionTime;

export default statusBarSlice.reducer;
